import React from 'react'
import { Grid } from '@material-ui/core'
import { components } from 'cng-web-lib'

import PingCgMigrationApiUrls from 'src/apiUrls/ping/cg-migration/PingCgMigrationApiUrls'
import FormProperties from './PingCgMigrationLogs_PatchBatchLogFormProperties'

const {
    table: { CngServerModeDialogFormTable, DateTimeRangeFilter }
} = components

function TablePage(props) {

    const { showNotification } = props

    // Translations ------------------------------------------------------------
    // This is just a temporary feature. Translation not implemented.

    //* Table Columns ----------------------------------------------------------
    const columns = [
        { field: 'id', title: 'ID', type: 'numeric' },
        { field: 'elapsedTime', title: 'Elapsed Time', type: 'numeric' },
        { field: 'summary', title: 'Summary' },
        { field: 'successCount', title: 'Success', type: 'numeric' },
        { field: 'errorCount', title: 'Error', type: 'numeric' },
        { field: 'warningCount', title: 'Warning', type: 'numeric' },
        { field: 'totalCount', title: 'Total', type: 'numeric' },
        {
            field: 'createdDate', title: 'Created Date',
            type: "datetime", defaultSort: 'desc',
            filterComponent: DateTimeRangeFilter
        }
    ]

    //* return JSX -------------------------------------------------------------
    return (

        //* Start JSX ----------------------------------------------------------
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <CngServerModeDialogFormTable
                    fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'

                    showNotification={showNotification}
                    tableColumns={columns}

                    formProperties={FormProperties}

                    fetch={{ url: PingCgMigrationApiUrls.PATCH_BATCH_LOG_GET }}
                    idAccessor='id'

                    disabled={true} // To remove the create/edit/delete buttons.
                />
            </Grid>
        </Grid>
        //* End JSX ------------------------------------------------------------

    );

    //* End of function --------------------------------------------------------
}

export default TablePage
